/**
 * Como cada motor se chama NA TELA.
 *
 * ── Por que existe uma tradução ───────────────────────────────────────────
 *
 * "Chatwoot" e "Keycloak" são o nome dos produtos que sustentam o atendimento e
 * o login por dentro (o Twenty, que sustentava o cadastro, saiu na #705). Quem usa o CliqCRM nunca ouviu
 * falar deles, não escolheu nenhum e não pode fazer nada a respeito — e um
 * nome próprio na tela leva a pessoa a procurar o que ele significa em vez de
 * ler a linha.
 *
 * É a mesma regra que a casca já seguia: o menu fala do trabalho ("Atendimento",
 * "Clientes"), e não da peça que o executa. Aqui ela alcança o único lugar onde
 * o nome cru ainda saía — a saúde das integrações, que imprimia `provider` como
 * veio do banco: `chatwoot`, em minúsculo.
 *
 * ── Quem não está na lista aparece como está ──────────────────────────────
 *
 * Portal de anúncio é nome que a pessoa CONHECE e usa: "webmotors" é a conta
 * dela lá, e traduzir isso a ajudaria em nada. A lista cobre só o que é
 * bastidor; o resto passa com a primeira letra maiúscula, que é o suficiente
 * para um identificador de banco virar rótulo.
 *
 * ── O par do lado do servidor ─────────────────────────────────────────────
 *
 * `ENGINES` em `apps/api/src/integracoes/conexoes.ts` carrega o mesmo rótulo do
 * atendimento, porque a tela de Conexões recebe o nome já pronto da API. Mudar um
 * sem o outro faz a mesma engine ter dois nomes em duas telas.
 */

/*
 * Os rótulos dizem o TRABALHO, e não a categoria de software.
 *
 * Eram "Chat" e "CRM". Os dois ainda eram vocabulário nosso: "CRM" é sigla de
 * mercado que uma clínica não usa, e ensina a abrir chamado falando de CRM.
 * Agora eles casam com o que a pessoa vê no menu e nas colunas — "Atendimento"
 * é o item do menu, "Cadastro" é a coluna da tela de Pessoas.
 */
const NOME_NA_TELA: Readonly<Record<string, string>> = {
  chatwoot: 'Atendimento',
  /*
   * O cadastro comercial, que é nosso desde a #699: a API o chama de `crm` nos
   * passos de uma pessoa e no resultado da exclusão (#707).
   */
  crm: 'Cadastro',
  /*
   * A origem `twenty` ainda aparece nos vínculos de identidade gravados antes
   * da 069, até a eliminação dos dados legados (#711).
   */
  twenty: 'Cadastro',
  /*
   * O provedor de identidade entra pela mesma porta, e pela mesma razão.
   *
   * Ele aparece em "o que aconteceu em cada motor" quando alguém é cadastrado,
   * reprovisionado ou desativado — e "keycloak" é ainda mais opaco que os
   * outros dois: quem lê não tem nem como adivinhar que aquilo é o login.
   */
  keycloak: 'Acesso',
};

export function nomeDoProvedor(provider: string): string {
  return NOME_NA_TELA[provider] ?? provider.charAt(0).toUpperCase() + provider.slice(1);
}
